<!-- <section class="section b-b">
  <div class="container">
    <div class="row gap-y align-items-center text-center text-lg-left">
      <div class="col-12 col-md-6 py-4 px-5 b-md-r">
        <dc-feather
          [name]="'dollar-sign'"
          [iconClass]="'stroke-darker'"
        ></dc-feather>
        <a
          href="javascript:;"
          class="mt-4 text-darker d-flex align-items-center"
        >
          <h4 class="mr-3">Contacto comercial</h4>
          <fa-icon [icon]="longArrowAltRight"></fa-icon>
        </a>
        <p class="mt-4">
          ¿Busca un presupuesto personalizado? ¿Necesita contarnos más sobre su
          empresa? ¿O quiere una demostración? Envíenos un email a
          <a href="mailto:comercial@incloudsolutions.es" style="color: #00365F;"
            >comercial@incloudsolutions.es</a
          >
        </p>
      </div>

      <div class="col-12 col-md-6 py-4 px-5">
        <dc-feather
          [name]="'life-buoy'"
          [iconClass]="'stroke-darker'"
        ></dc-feather>
        <a
          href="javascript:;"
          class="mt-4 text-darker d-flex align-items-center"
        >
          <h4 class="mr-3">Soporte técnico</h4>
          <fa-icon [icon]="longArrowAltRight"></fa-icon>
        </a>
        <p class="mt-4">
          ¿Alguna duda sobre cómo integrar su producto? No se preocupe, nuestro
          equipo técnico está listo para usted en
          <a href="mailto:info@grupox3.es" style="color: #00365F;"
            >info@grupox3.es</a
          >
        </p>
      </div>
    </div>
  </div>
</section> -->
